
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-77a4f65d&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./noticeList.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./noticeList.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-77a4f65d!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./noticeList.vue"),
  /* scopeId */
  "data-v-77a4f65d",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/staging/noticeList.vue
// module id = 1575
// module chunks = 3